import PropTypes from 'prop-types'
import Sidebar from './sidebar'
import Canvas from './canvas'
import React from 'react'

class AnnouncmentDesigner extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.object,
    onChange: PropTypes.func,
    onSave: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {}
  }

  state = {
    announcement: null,
    dirty: false
  }

  _handleSave = this._handleSave.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.announcement) return null
    return (
      <div className="maha-announcement-designer">
        <Canvas { ...this._getCanvas() } />
        <Sidebar { ...this._getSidebar() } />
      </div>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    this._handleSet(defaultValue)
  }

  componentDidUpdate(prevProps, prevState) {
    const { announcement } = this.state
    if(!_.isEqual(announcement, prevState.announcement)) {
      this._handleChange()
    }
  }

  _getCanvas() {
    const { announcement } = this.state
    return {
      announcement
    }
  }

  _getSidebar() {
    const { announcement, dirty } = this.state
    const { onSave } = this.props
    return {
      announcement,
      dirty,
      onChange: this._handleUpdate,
      onSave: onSave ? this._handleSave : null
    }
  }

  _handleSave(announcement) {
    this.props.onSave(announcement)
    this.setState({
      dirty: false
    })
  }

  _handleChange() {
    const { announcement } = this.state
    this.props.onChange({
      author: announcement.author ? {
        user_id: announcement.author.user.id
      } : null,
      images: announcement.images?.map(image => ({
        asset_id: image.asset.id,
        transforms: image.transforms
      })) || null,
      body: announcement.body,
      cta: announcement.cta
    })
  }

  _handleSet(announcement) {
    this.setState({ 
      announcement: announcement || {}
    })
  }

  _handleUpdate(announcement) {
    this.setState({ 
      announcement,
      dirty: true
    })
  }

}

export default AnnouncmentDesigner
